<template>
  <div class="w-full h-full">
    <el-table
      :data="tableData"
      highlight-current-row
      class="!h-[calc(100%-100px)] !w-full"
      ref="tableRef"
      v-loading="tableLoading"
    >
      <el-table-column label="序号" type="index" width="60" :index="indexMethod"> </el-table-column>
      <el-table-column
        v-for="(item, index) in tableColumns"
        :key="index"
        :label="item.label"
        :width="item.width"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div
            v-if="item.type === 'ThreeDimensional'"
            @click="moveThreeD(scope.row)"
            class="cursor-pointer text-hex-00bcc8 truncate"
          >
            {{ scope.row[item.prop] }}
          </div>
          <div v-else class="truncate">
            {{ scope.row[item.prop] }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @size-change="getTableData()"
      @current-change="getTableData()"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :pager-count="5"
      layout="total, prev, pager, next"
      :total="page.total"
      class="text-center"
    ></el-pagination>
  </div>
</template>

<script>
import { OperateTicketApi } from '@wiz-api/ji-nan-re-dian'
import { operationConfig } from './config'

const operateTicketApi = new OperateTicketApi()
export default {
  props: {
    player: {
      type: Object,
      default: () => {},
    },
    transferProps: {
      type: Object,
      defalut: () => {},
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tableData: [],
      tableLoading: true,
      title: '两票清单',
      id: '',
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      mockData: {
        code: 0,
        message: '操作成功',
        data: {
          totalCount: 1,
          items: [
            {
              id: '1381917465801416705',
              createId: '1381864275269718018',
              createTime: '2021-04-13T10:29:33.288185Z',
              lastModifyId: '1381864275269718018',
              lastModifyTime: '2021-04-16T06:15:51.349296Z',
              title: null,
              taskName: '测试操作票041301',
              taskNo: null,
              serialNo: null,
              state: 'WaitCommit',
              stateDescription: '待提交',
              beginTime: null,
              endTime: null,
              riskLevel: 'None',
              remark: '备注',
              workflowId: null,
              hasPermission: false,
              formKey: null,
              isSinglePersonOperation: false,
              ticketType: null,
              ticketTypeName: null,
              profession: null,
              workgroup: null,
              department: null,
              ppeCheck: null,
              ppeCheckTime: null,
              ticketTaskPersonas: [],
              ticketRatePersonas: null,
              allTicketTaskPersonas: [
                {
                  roleType: 'Operator',
                  roleTypeName: '操作人',
                  step: 1,
                },
                {
                  roleType: 'Guardian',
                  roleTypeName: '监护人',
                  step: 2,
                },
                {
                  roleType: 'Approver',
                  roleTypeName: '值长',
                  step: 3,
                },
              ],
              handOnBoardCount: 0,
              handOnCommonLockCount: 0,
              deviceInfo: {
                lockCabinetList: null,
                wireCabinetList: null,
              },
              fileList: null,
              dataSourceFrom: '3D',
              commandTime: null,
              commandCommander: null,
              commandReceiver: null,
              reportTime: null,
              reportCommander: null,
              reportReceiver: null,
              isFinished: false,
              commonLockList: null,
              boardInfoList: null,
              hasExpired: null,
              deviceAreaList: null,
            },
          ],
        },
        success: true,
      },
    }
  },
  watch: {
    transferProps: {
      handler(data) {
        this.page.pageNo = 1
        this.getTableData()
      },
      deep: true,
      immediate: true,
    },
    type: {
      handler(data) {
        this.page.pageNo = 1
        this.getTableData()
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    tableColumns() {
      return operationConfig.pipelineSecondaryLedger.tableHead
    },
  },
  async mounted() {},
  methods: {
    indexMethod(index) {
      if (index < 10) {
        return `0${index + 1}`
      }
      return index + 1
    },
    async getTableData(deviceName) {
      this.tableLoading = true
      const [err, res] = await operateTicketApi.getPagedList({
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      })
      if (!err) {
        this.tableData = res.items
        this.page.total = res.totalCount
      }
      this.tableLoading = false
    },
    async searchData() {
      this.page.pageNo = 1
      await this.getTableData()
    },
  },
  async beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background-color: #1e4960 !important;
  opacity: 1 !important;
}
::v-deep .el-pagination.is-background.el-pagination--small .el-pager li {
  min-width: 24px;
  margin: 0 5px;
  padding: 0 4px;
}
</style>
